import { createReducer, isFetched, isFetching } from "../../utils/reducer"
import { ADMIN_SET, ADMIN_REQUEST, ADMIN_REQUEST_DONE } from "../actions/adminActions"

const initialState = {
	isFetching: true,
	data: {
		user_count: 0,
	},
}

export const setAdmin = (state, data) => {
	return { ...state, data: data }
}

export default createReducer(initialState, {
	[ADMIN_SET]: setAdmin,
	[ADMIN_REQUEST]: isFetching,
	[ADMIN_REQUEST_DONE]: isFetched,
})
